import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { CategoriaProduto } from '../../types/estoque';
import { categoriasProdutoService } from '../../services';

const columns: ResourceColumn<CategoriaProduto>[] = [
  { header: 'Nome', accessor: 'nome' },
  { header: 'Descrição', accessor: 'descricao' },
  { header: 'Ativo', render: (item) => (item.ativo === false ? 'Não' : 'Sim') },
];

export const TiposProdutoListPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <ResourceListPage
      title="Categorias de produto"
      description="Categorias base para o catálogo de produtos."
      columns={columns}
      service={categoriasProdutoService}
      createPath="/admin/estoque/tipos-produto/novo"
      onEdit={(item) =>
        (item as { id?: number }).id &&
        navigate('/admin/estoque/tipos-produto/editar', { state: { record: item } })
      }
      onDelete={(item) =>
        (item as { id?: number }).id
          ? categoriasProdutoService.remove((item as any).id)
          : Promise.resolve()
      }
    />
  );
};
